/**
 * 驗證字串是否為可用的 http(s) URL。
 *
 * 不使用 `filterInvalidDomains` 的 `/^https?:\/\//`：該正則大小寫敏感（誤殺 `HTTPS://…`），
 * 且會放行沒有 hostname 的 `https://`。
 */
export const isValidHttpUrl = (value: string): boolean => {
  let url: URL
  try {
    url = new URL(value)
  } catch {
    return false
  }
  return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname !== ''
}
